import { render } from "./Credentials.vue?vue&type=template&id=08a4ac6b&scoped=true"
import script from "./Credentials.vue?vue&type=script&lang=js"
export * from "./Credentials.vue?vue&type=script&lang=js"

import "./Credentials.vue?vue&type=style&index=0&id=08a4ac6b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a4ac6b"]])

export default __exports__